import React, { lazy } from 'react';
import Loadable from 'app/components/Loadable/Loadable';

const PersonalInformation = Loadable(
  lazy(() => import('./PersonalInformation'))
);

const formsRoutes = [
  {
    // path: '/ninja/property-listing-form',
    // element: <PersonalInformation />,
  },
];

export default formsRoutes;
